import React, { useState } from "react";
import { Link } from "react-router-dom";

import deleteAccount1 from "../assets/deleteAccount1.jpeg"
import deleteAccount2 from "../assets/deleteAccount2.jpeg"
import deleteAccount3 from "../assets/deleteAccount3.jpeg"
import deleteAccount4 from "../assets/deleteAccount4.jpeg"


export const AccountDeletion = () => {
    const [currentStep, setCurrentStep] = useState(null);

    const steps = [
        {
            number: 1,
            title: "Access Your Profile",
            description: "From the home screen, tap on your profile icon in the top right corner (shows your profile picture (or initials) and flag).",
            icon: "👤",
            image: deleteAccount1
        },
        {
            number: 2,
            title: "Open Settings",
            description: "On your profile page, tap the settings gear icon in the top right corner.",
            icon: "⚙️",
            image: deleteAccount2
        },
        {
            number: 3,
            title: "Scroll to Subscriptions",
            description: "Scroll down past the Privacy and Strategy View sections until you reach the Subscriptions section.",
            icon: "📜",
            image: deleteAccount3
        },
        {
            number: 4,
            title: "Request Account Deletion",
            description: "Tap the 'Request Account Deletion' button at the bottom of the settings page.",
            icon: "🗑️",
            image: deleteAccount4
        },
        {
            number: 5,
            title: "Re-authenticate",
            description: "You'll be prompted to re-authenticate yourself to confirm the deletion request. Follow the on-screen instructions to complete the process.",
            icon: "🔐"
        }
    ];

    return (
        <div style={{
            maxWidth: '900px',
            margin: '0 auto',
            padding: '40px 20px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            lineHeight: '1.6',
            color: '#333',
            backgroundColor: '#f8f9fa',
            minHeight: '100vh'
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '40px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
                <h1 style={{
                    fontSize: '32px',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    marginBottom: '16px',
                    textAlign: 'center'
                }}>
                    How to Delete Your Account
                </h1>

                <p style={{
                    fontSize: '18px',
                    color: '#666',
                    textAlign: 'center',
                    marginBottom: '40px',
                    maxWidth: '600px',
                    margin: '0 auto 40px'
                }}>
                    Follow these steps to permanently delete your account. Please note that this action cannot be undone.
                </p>

                <div style={{
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffc107',
                    borderRadius: '8px',
                    padding: '16px 20px',
                    marginBottom: '40px',
                    display: 'flex',
                    alignItems: 'start',
                    gap: '12px'
                }}>
                    <span style={{ fontSize: '24px' }}>⚠️</span>
                    <div>
                        <strong style={{ color: '#856404' }}>Important:</strong>
                        <span style={{ color: '#856404', marginLeft: '8px' }}>
                            Deleting your account will permanently remove all your data, including hand history, statistics, and profile information.
                        </span>
                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '24px'
                }}>
                    {steps.map((step, index) => (
                        <div
                            key={step.number}
                            onClick={() => setCurrentStep(currentStep === index ? null : index)}
                            style={{
                                backgroundColor: currentStep === index ? '#f0f7ff' : '#fff',
                                border: `2px solid ${currentStep === index ? '#0066cc' : '#e0e0e0'}`,
                                borderRadius: '12px',
                                padding: '24px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                transform: currentStep === index ? 'scale(1.02)' : 'scale(1)',
                                boxShadow: currentStep === index ? '0 4px 12px rgba(0,102,204,0.15)' : '0 1px 3px rgba(0,0,0,0.05)'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                marginBottom: currentStep === index ? '16px' : '0'
                            }}>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '50%',
                                    backgroundColor: currentStep === index ? '#0066cc' : '#e8e8e8',
                                    color: currentStep === index ? '#fff' : '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px',
                                    fontWeight: '700',
                                    flexShrink: 0
                                }}>
                                    {step.number}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <h3 style={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        color: '#1a1a1a',
                                        margin: 0
                                    }}>
                                        {step.icon} {step.title}
                                    </h3>
                                </div>
                                <div style={{
                                    fontSize: '20px',
                                    color: currentStep === index ? '#0066cc' : '#999',
                                    transition: 'transform 0.3s ease',
                                    transform: currentStep === index ? 'rotate(180deg)' : 'rotate(0deg)'
                                }}>
                                    ▼
                                </div>
                            </div>

                            {currentStep === index && (
                                <div style={{
                                    paddingLeft: '64px',
                                    fontSize: '16px',
                                    color: '#555',
                                    lineHeight: '1.7'
                                }}>
                                    {step.description}
                                    {step.image && (
                                        <div style={{
                                            marginTop: '20px',
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            border: '2px solid #e0e0e0',
                                            maxWidth: '400px'
                                        }}>
                                            <img
                                                src={step.image}
                                                alt={`Step ${step.number}: ${step.title}`}
                                                style={{
                                                    width: '100%',
                                                    height: 'auto',
                                                    display: 'block'
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>



                <div style={{
                    marginTop: '32px',
                    textAlign: 'center',
                    fontSize: '14px',
                    color: '#999'
                }}>
                    Account deletion is permanent and cannot be reversed.
                </div>

                <p style={{
                    marginTop: '16px',
                    textAlign: 'center',
                    fontSize: '15px',
                    color: '#555'
                }}>
                    Don't have the app any more, or can't sign in?{' '}
                    <Link to="/support#delete-account" style={{ color: '#0066cc' }}>Request deletion by email</Link>.
                </p>
            </div>
        </div>
    );
};

export default AccountDeletion;